const rankings = [
  {
    rank: 1,
    title: '长安十二时辰',
    meta: '古装悬疑 · 9.2分',
    heat: '980万',
    change: 'up',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20abstract%20visual%20with%20dramatic%20lighting%20warm%20amber%20tones%20dark%20atmosphere%20film%20noir%20aesthetic%20elegant%20composition%20no%20text%20no%20people%20artistic%20minimalist&width=200&height=256&seq=ranking-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '流浪地球3',
    meta: '科幻冒险 · 8.9分',
    heat: '860万',
    change: 'up',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20cinematic%20poster%20style%20abstract%20visual%20deep%20space%20tones%20dramatic%20contrast%20warm%20golden%20accents%20dark%20atmosphere%20artistic%20minimalist%20no%20text&width=200&height=256&seq=ranking-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '这！就是街舞7',
    meta: '综艺竞技 · 9.0分',
    heat: '750万',
    change: 'new',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20dance%20performance%20abstract%20visual%20with%20vibrant%20energy%20warm%20stage%20lighting%20dark%20background%20artistic%20motion%20blur%20cinematic%20style%20no%20text&width=200&height=256&seq=ranking-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '狂飙',
    meta: '犯罪剧情 · 9.5分',
    heat: '720万',
    change: 'down',
    img: 'https://readdy.ai/api/search-image?query=Crime%20drama%20cinematic%20poster%20abstract%20visual%20dark%20moody%20atmosphere%20warm%20orange%20highlights%20film%20noir%20aesthetic%20artistic%20minimalist%20no%20text&width=200&height=256&seq=ranking-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '庆余年2',
    meta: '古装权谋 · 9.3分',
    heat: '680万',
    change: 'up',
    img: 'https://readdy.ai/api/search-image?query=Historical%20drama%20cinematic%20poster%20abstract%20visual%20ancient%20Chinese%20aesthetic%20warm%20golden%20tones%20dark%20elegant%20atmosphere%20artistic%20minimalist%20no%20text&width=200&height=256&seq=ranking-05&orientation=portrait',
  },
  {
    rank: 6,
    title: '繁花',
    meta: '都市情感 · 9.1分',
    heat: '610万',
    change: 'down',
    img: 'https://readdy.ai/api/search-image?query=Urban%20romance%20cinematic%20poster%20abstract%20visual%20warm%20nostalgic%20tones%20dark%20atmospheric%20background%20elegant%20composition%20artistic%20minimalist%20no%20text&width=200&height=256&seq=ranking-06&orientation=portrait',
  },
];

export default function RankingSection() {
  const changeIcon = (c: string) => {
    if (c === 'up') return <i className="ri-arrow-up-line text-accent-500"></i>;
    if (c === 'down') return <i className="ri-arrow-down-line text-foreground-600"></i>;
    return <span className="text-[10px] text-primary-400 font-bold">NEW</span>;
  };

  return (
    <section id="ranking" className="relative py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">热播风云榜</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">实时热度排行，发现全网最受欢迎的影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {rankings.map((item) => (
            <div key={item.rank} className="group flex items-center gap-4 bg-background-100 rounded-xl p-4 border border-background-200/50 hover:border-primary-500/20 transition-colors cursor-pointer">
              <div className="relative flex-shrink-0 w-16 h-20 md:w-20 md:h-24 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-0 left-0 w-6 h-6 flex items-center justify-center bg-background-950/80 text-primary-400 text-xs font-bold rounded-br-lg">
                  {item.rank}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-foreground-100 font-semibold text-sm md:text-base truncate">{item.title}</h3>
                <p className="text-foreground-500 text-xs mt-1">{item.meta}</p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-xs text-primary-400 font-medium">{item.heat}热度</span>
                  <span className="flex items-center">{changeIcon(item.change)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-2 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
          >
            查看完整榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}